import { gql } from '@apollo/client';

export const fetchEspAccountsQuery = gql`
  query FetchEspAccounts {
    espAccounts {
      id
      name
      esp
      binding
      customApiEndpoint
      truncatedApiKey
      isDefault
      projectId
    }
  }
`;

export const fetchEspAccountsQueryWithWhatsApp = gql`
  query FetchEspAccounts {
    espAccounts {
      id
      name
      esp
      binding
      customApiEndpoint
      truncatedApiKey
      isDefault
      projectId
      senders {
        ... on WhatsAppSender {
          id
          senderId
          phoneNumber
          qualityRating
          status
          sendLimit
          about
          address
          description
          email
          vertical
          websites
          displayName
        }
      }
    }
  }
`;
